module.exports = __webpack_public_path__ + "img/list1.5b114655.png";